// extracted by mini-css-extract-plugin
export default {"menu":"actions_menu__bcLjo","menuItem":"actions_menuItem__-noz3","menuOpen":"actions_menuOpen__ef3R2","menuAdd":"actions_menuAdd__zV5h7"};